/**
 *
 * @author Matthew Rawson @ 02/05/2018 10:02
 * @description
 * @notes
 */
import React, {Fragment} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import id from "@irati/utils/id"
import {Para} from "@irati/ui/src/Labels"
import Link from "@irati/ui/src/Link"

import {isScheduleEnabled} from "../../../helpers/schedule"

const Customisation = ({schedule, ...props}) => {
  const idNamespace = id("Customisation", props)
  const isEnabled = isScheduleEnabled(schedule)
  const tenantPlaceholder = get(schedule, "preferences.placeholders.tenant")
  const isActionBoardEnabled = get(schedule, "preferences.includeActionBoard")
  const actionBoardUrl = get(schedule, "preferences.actionBoardUrl")

  return (
    <Fragment>
      {isEnabled && (
        <Fragment>
          <Para id={id("tenant", idNamespace)}>
            Your company name will appear in the survey questions as <strong>{tenantPlaceholder}</strong>.
          </Para>

          {isActionBoardEnabled && (
            <Para id={id("action-board", idNamespace)}>
              <span>Your </span>
              <Link
                id={id("action-board-url", idNamespace)}
                href={actionBoardUrl}
                target="_BLANK">action board</Link>
              <span> will be displayed at the end of each survey.</span>
            </Para>
          )}

          {!isActionBoardEnabled && (
            <Para id={id("action-board-not", idNamespace)}>
              Your action board will <strong>not</strong> be displayed at the end of each survey.
            </Para>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

Customisation.propTypes = {
  schedule: PropTypes.object
}
Customisation.defaultProps = {
  schedule: {}
}

export default Customisation
